(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './mobile-platform-common-common-platform-sdk.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./mobile-platform-common-common-platform-sdk.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'events-project:events'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'events-project:events'.");
    }
    if (typeof this['mobile-platform-common-common-platform-sdk'] === 'undefined') {
      throw new Error("Error loading module 'events-project:events'. Its dependency 'mobile-platform-common-common-platform-sdk' was not found. Please, check whether 'mobile-platform-common-common-platform-sdk' is loaded prior to 'events-project:events'.");
    }
    root['events-project:events'] = factory(typeof this['events-project:events'] === 'undefined' ? {} : this['events-project:events'], this['kotlin-kotlin-stdlib'], this['mobile-platform-common-common-platform-sdk']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_careem_mobile_common_platform_sdk) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.w4;
  var Unit_instance = kotlin_kotlin.$_$.m2;
  var classMeta = kotlin_kotlin.$_$.y3;
  var setMetadataFor = kotlin_kotlin.$_$.x4;
  var VOID = kotlin_kotlin.$_$.e;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.n;
  var equals = kotlin_kotlin.$_$.g5;
  var objectMeta = kotlin_kotlin.$_$.v4;
  var THROW_IAE = kotlin_kotlin.$_$.x5;
  var enumEntries = kotlin_kotlin.$_$.r3;
  var Enum = kotlin_kotlin.$_$.r5;
  var defineProp = kotlin_kotlin.$_$.z3;
  var emptySet = kotlin_kotlin.$_$.g3;
  var SchemaDefinition = kotlin_com_careem_mobile_common_platform_sdk.$_$.c;
  var setOf = kotlin_kotlin.$_$.l3;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.j;
  var EventDefinition = kotlin_com_careem_mobile_common_platform_sdk.$_$.b;
  var EventImpl = kotlin_com_careem_mobile_common_platform_sdk.$_$.d;
  var EventBuilder = kotlin_com_careem_mobile_common_platform_sdk.$_$.a;
  //endregion
  //region block: pre-declaration
  setMetadataFor(LndrDomainHolder, 'LndrDomainHolder', classMeta, VOID, VOID, LndrDomainHolder);
  setMetadataFor(LndrDomainHolder_0, 'LndrDomainHolder', classMeta, VOID, VOID, LndrDomainHolder_0);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(ButtonSize, 'ButtonSize', classMeta, Enum);
  setMetadataFor(ButtonType, 'ButtonType', classMeta, Enum);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(LndrTapButtonEventBuilder, 'LndrTapButtonEventBuilder', classMeta, VOID, [EventBuilder]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(LndrViewPageEventBuilder, 'LndrViewPageEventBuilder', classMeta, VOID, [EventBuilder]);
  //endregion
  function LndrDomainHolder() {
    this.dt_1 = new LndrDomainHolder_0();
  }
  protoOf(LndrDomainHolder).et = function (_set____db54di) {
    this.dt_1 = _set____db54di;
  };
  protoOf(LndrDomainHolder).wr = function () {
    return this.dt_1;
  };
  protoOf(LndrDomainHolder).tenantService = function (value) {
    this.dt_1.ht(value);
    var result = Unit_instance;
    return result;
  };
  protoOf(LndrDomainHolder).addSchema = function (builder) {
    var result = this.dt_1.it(builder);
    return result;
  };
  function _ButtonName___get_value__impl__bglgpk($this) {
    return $this;
  }
  function addToState($this, key, value) {
    if (!(value == null)) {
      // Inline function 'kotlin.collections.set' call
      $this.gt_1.l1(key, value);
    } else {
      $this.gt_1.m1(key);
    }
  }
  function LndrDomainHolder_0() {
    this.ft_1 = 'domain';
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.gt_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(LndrDomainHolder_0).ht = function (value) {
    addToState(this, 'tenant_service', value);
  };
  protoOf(LndrDomainHolder_0).it = function (builder) {
    return builder.addSchema(this.ft_1, this.gt_1);
  };
  var ButtonSize_NULL_instance;
  var ButtonSize_LG_instance;
  function Companion() {
  }
  protoOf(Companion).fromValue = function (value) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_entries();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.n();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.v();
        // Inline function 'com.careem.mobile.analytics.tenants_laundry_by_washmen.Companion.fromValue.<anonymous>' call
        if (equals(element.value, value, true)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function values() {
    return [ButtonSize_NULL_getInstance(), ButtonSize_LG_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'NULL':
        return ButtonSize_NULL_getInstance();
      case 'LG':
        return ButtonSize_LG_getInstance();
      default:
        ButtonSize_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var ButtonSize_entriesInitialized;
  function ButtonSize_initEntries() {
    if (ButtonSize_entriesInitialized)
      return Unit_instance;
    ButtonSize_entriesInitialized = true;
    ButtonSize_NULL_instance = new ButtonSize('NULL', 0, 'NULL');
    ButtonSize_LG_instance = new ButtonSize('LG', 1, 'lg');
  }
  var $ENTRIES;
  var ButtonType_NULL_instance;
  var ButtonType_SUBMIT_instance;
  function Companion_0() {
  }
  protoOf(Companion_0).fromValue = function (value) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_entries_0();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.n();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.v();
        // Inline function 'com.careem.mobile.analytics.tenants_laundry_by_washmen.Companion.fromValue.<anonymous>' call
        if (equals(element.value, value, true)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function values_0() {
    return [ButtonType_NULL_getInstance(), ButtonType_SUBMIT_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'NULL':
        return ButtonType_NULL_getInstance();
      case 'SUBMIT':
        return ButtonType_SUBMIT_getInstance();
      default:
        ButtonType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_0());
    return $ENTRIES_0;
  }
  var ButtonType_entriesInitialized;
  function ButtonType_initEntries() {
    if (ButtonType_entriesInitialized)
      return Unit_instance;
    ButtonType_entriesInitialized = true;
    ButtonType_NULL_instance = new ButtonType('NULL', 0, 'NULL');
    ButtonType_SUBMIT_instance = new ButtonType('SUBMIT', 1, 'submit');
  }
  var $ENTRIES_0;
  function ButtonSize(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ButtonSize).p1 = function () {
    return this.value;
  };
  function ButtonType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ButtonType).p1 = function () {
    return this.value;
  };
  function ButtonSize_NULL_getInstance() {
    ButtonSize_initEntries();
    return ButtonSize_NULL_instance;
  }
  function ButtonSize_LG_getInstance() {
    ButtonSize_initEntries();
    return ButtonSize_LG_instance;
  }
  function ButtonType_NULL_getInstance() {
    ButtonType_initEntries();
    return ButtonType_NULL_instance;
  }
  function ButtonType_SUBMIT_getInstance() {
    ButtonType_initEntries();
    return ButtonType_SUBMIT_instance;
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    var tmp_0 = new SchemaDefinition('default/mobile_sdk_v22', 'platform', tmp$ret$0);
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$1 = emptySet();
    var tmp_1 = new SchemaDefinition('default/tap_v2', 'action', tmp$ret$1);
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$2 = emptySet();
    var tmp_2 = new SchemaDefinition('tenants_laundry_by_washmen/button_v3', 'object', tmp$ret$2);
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$3 = emptySet();
    tmp.nt_1 = setOf([tmp_0, tmp_1, tmp_2, new SchemaDefinition('tenants_laundry_by_washmen/lndr_v5', 'domain', tmp$ret$3)]);
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function LndrTapButtonEventBuilder(buttonName, pageName, tenantService) {
    Companion_getInstance_1();
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.ot_1 = HashMap_init_$Create$();
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'button_name';
    var value = _ButtonName___get_value__impl__bglgpk(buttonName);
    this_0.l1(key, value);
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.ot_1;
    var key_0 = 'page_name';
    var value_0 = _PageName___get_value__impl__wan8yt(pageName);
    this_1.l1(key_0, value_0);
    // Inline function 'kotlin.collections.set' call
    var this_2 = this.ot_1;
    var key_1 = 'tenant_service';
    var value_1 = _TenantService___get_value__impl__1axny6(tenantService);
    this_2.l1(key_1, value_1);
  }
  protoOf(LndrTapButtonEventBuilder).buttonName = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'button_name';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).buttonSize = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'button_size';
    var value_0 = value.value;
    this_0.l1(key, value_0);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).buttonType = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'button_type';
    var value_0 = value.value;
    this_0.l1(key, value_0);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).pageName = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'page_name';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).positionX = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'position_x';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).pt = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'position_x';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).positionY = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'position_y';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).qt = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'position_y';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).tenantService = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'tenant_service';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).addSchema = function (type, args) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = Companion_getInstance_1().nt_1.n();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.v();
        // Inline function 'com.careem.mobile.analytics.tenants_laundry_by_washmen.LndrTapButtonEventBuilder.addSchema.<anonymous>' call
        if (element.ks_1 === type) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    if (!(tmp$ret$1 == null)) {
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_0 = args.n1().n();
      while (tmp0_iterator_0.u()) {
        var tmp1_loop_parameter = tmp0_iterator_0.v();
        // Inline function 'kotlin.collections.component1' call
        var key = tmp1_loop_parameter.o1();
        // Inline function 'kotlin.collections.component2' call
        var value = tmp1_loop_parameter.p1();
        if (!this.ot_1.s1(key)) {
          // Inline function 'kotlin.collections.set' call
          this.ot_1.l1(key, value);
        }
      }
    }
    return this;
  };
  protoOf(LndrTapButtonEventBuilder).build = function () {
    var version = 7;
    var name = 'lndr_tap_button';
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.ot_1;
    var key = 'event_version';
    this_0.l1(key, version);
    return new EventImpl(new EventDefinition(version, name), this.ot_1);
  };
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    var tmp_0 = new SchemaDefinition('default/mobile_sdk_v22', 'platform', tmp$ret$0);
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$1 = emptySet();
    var tmp_1 = new SchemaDefinition('default/view_v2', 'action', tmp$ret$1);
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$2 = emptySet();
    var tmp_2 = new SchemaDefinition('tenants_laundry_by_washmen/lndr_v5', 'domain', tmp$ret$2);
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$3 = emptySet();
    tmp.rt_1 = setOf([tmp_0, tmp_1, tmp_2, new SchemaDefinition('tenants_laundry_by_washmen/page_v5', 'object', tmp$ret$3)]);
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function LndrViewPageEventBuilder(pageName, tenantService) {
    Companion_getInstance_2();
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.st_1 = HashMap_init_$Create$();
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'page_name';
    var value = _PageName___get_value__impl__wan8yt(pageName);
    this_0.l1(key, value);
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.st_1;
    var key_0 = 'tenant_service';
    var value_0 = _TenantService___get_value__impl__1axny6(tenantService);
    this_1.l1(key_0, value_0);
  }
  protoOf(LndrViewPageEventBuilder).pageId = function (value) {
    // Inline function 'kotlin.collections.set' call
    this.st_1.l1('page_id', value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).tt = function (value) {
    // Inline function 'kotlin.collections.set' call
    this.st_1.l1('page_id', value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).pageName = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'page_name';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).pageNumber = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'page_number';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).ut = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'page_number';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).screenSizeHeight = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'screen_size_height';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).vt = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'screen_size_height';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).screenSizeWidth = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'screen_size_width';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).wt = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'screen_size_width';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).tenantService = function (value) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'tenant_service';
    this_0.l1(key, value);
    return this;
  };
  protoOf(LndrViewPageEventBuilder).addSchema = function (type, args) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = Companion_getInstance_2().rt_1.n();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.v();
        // Inline function 'com.careem.mobile.analytics.tenants_laundry_by_washmen.LndrViewPageEventBuilder.addSchema.<anonymous>' call
        if (element.ks_1 === type) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    if (!(tmp$ret$1 == null)) {
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_0 = args.n1().n();
      while (tmp0_iterator_0.u()) {
        var tmp1_loop_parameter = tmp0_iterator_0.v();
        // Inline function 'kotlin.collections.component1' call
        var key = tmp1_loop_parameter.o1();
        // Inline function 'kotlin.collections.component2' call
        var value = tmp1_loop_parameter.p1();
        if (!this.st_1.s1(key)) {
          // Inline function 'kotlin.collections.set' call
          this.st_1.l1(key, value);
        }
      }
    }
    return this;
  };
  protoOf(LndrViewPageEventBuilder).build = function () {
    var version = 10;
    var name = 'lndr_view_page';
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.st_1;
    var key = 'event_version';
    this_0.l1(key, version);
    return new EventImpl(new EventDefinition(version, name), this.st_1);
  };
  function _PageName___get_value__impl__wan8yt($this) {
    return $this;
  }
  function _TenantService___get_value__impl__1axny6($this) {
    return $this;
  }
  //region block: post-declaration
  defineProp(protoOf(ButtonSize), 'name', protoOf(ButtonSize).j7);
  defineProp(protoOf(ButtonSize), 'ordinal', protoOf(ButtonSize).k7);
  defineProp(protoOf(ButtonType), 'name', protoOf(ButtonType).j7);
  defineProp(protoOf(ButtonType), 'ordinal', protoOf(ButtonType).k7);
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.LndrDomainHolder = LndrDomainHolder;
    var $com = _.com || (_.com = {});
    var $com$careem = $com.careem || ($com.careem = {});
    var $com$careem$mobile = $com$careem.mobile || ($com$careem.mobile = {});
    var $com$careem$mobile$analytics = $com$careem$mobile.analytics || ($com$careem$mobile.analytics = {});
    var $com$careem$mobile$analytics$tenants_laundry_by_washmen = $com$careem$mobile$analytics.tenants_laundry_by_washmen || ($com$careem$mobile$analytics.tenants_laundry_by_washmen = {});
    $com$careem$mobile$analytics$tenants_laundry_by_washmen.LndrTapButtonEventBuilder = LndrTapButtonEventBuilder;
    defineProp($com$careem$mobile$analytics$tenants_laundry_by_washmen.LndrTapButtonEventBuilder, 'Companion', Companion_getInstance_1);
    Companion_1.prototype.ButtonSize = ButtonSize;
    Companion_1.prototype.ButtonSize.values = values;
    Companion_1.prototype.ButtonSize.valueOf = valueOf;
    defineProp(Companion_1.prototype.ButtonSize, 'NULL', ButtonSize_NULL_getInstance);
    defineProp(Companion_1.prototype.ButtonSize, 'LG', ButtonSize_LG_getInstance);
    defineProp(Companion_1.prototype.ButtonSize, 'Companion', Companion_getInstance);
    Companion_1.prototype.ButtonType = ButtonType;
    Companion_1.prototype.ButtonType.values = values_0;
    Companion_1.prototype.ButtonType.valueOf = valueOf_0;
    defineProp(Companion_1.prototype.ButtonType, 'NULL', ButtonType_NULL_getInstance);
    defineProp(Companion_1.prototype.ButtonType, 'SUBMIT', ButtonType_SUBMIT_getInstance);
    defineProp(Companion_1.prototype.ButtonType, 'Companion', Companion_getInstance_0);
    var $com = _.com || (_.com = {});
    var $com$careem = $com.careem || ($com.careem = {});
    var $com$careem$mobile = $com$careem.mobile || ($com$careem.mobile = {});
    var $com$careem$mobile$analytics = $com$careem$mobile.analytics || ($com$careem$mobile.analytics = {});
    var $com$careem$mobile$analytics$tenants_laundry_by_washmen = $com$careem$mobile$analytics.tenants_laundry_by_washmen || ($com$careem$mobile$analytics.tenants_laundry_by_washmen = {});
    $com$careem$mobile$analytics$tenants_laundry_by_washmen.LndrViewPageEventBuilder = LndrViewPageEventBuilder;
    defineProp($com$careem$mobile$analytics$tenants_laundry_by_washmen.LndrViewPageEventBuilder, 'Companion', Companion_getInstance_2);
  }
  $jsExportAll$(_);
  kotlin_com_careem_mobile_common_platform_sdk.$jsExportAll$(_);
  //endregion
  return _;
}));


// 🔽 Auto-generated JavaScript Re-Exports 🔽
// Re-export with cleaner names
exports.LndrTapButtonEventBuilder = exports.com.careem.mobile.analytics.tenants_laundry_by_washmen.LndrTapButtonEventBuilder;

// For ButtonSize, we need to properly re-export the static members
const originalLndrTapButtonEventBuilder_ButtonSize = exports.com.careem.mobile.analytics.tenants_laundry_by_washmen.LndrTapButtonEventBuilder.Companion.ButtonSize;
exports.LndrTapButtonEventBuilder_ButtonSize = Object.create(originalLndrTapButtonEventBuilder_ButtonSize);

Object.defineProperties(exports.LndrTapButtonEventBuilder_ButtonSize, Object.getOwnPropertyDescriptors(originalLndrTapButtonEventBuilder_ButtonSize));

// For ButtonType, we need to properly re-export the static members
const originalLndrTapButtonEventBuilder_ButtonType = exports.com.careem.mobile.analytics.tenants_laundry_by_washmen.LndrTapButtonEventBuilder.Companion.ButtonType;
exports.LndrTapButtonEventBuilder_ButtonType = Object.create(originalLndrTapButtonEventBuilder_ButtonType);

Object.defineProperties(exports.LndrTapButtonEventBuilder_ButtonType, Object.getOwnPropertyDescriptors(originalLndrTapButtonEventBuilder_ButtonType));


// Re-export with cleaner names
exports.LndrViewPageEventBuilder = exports.com.careem.mobile.analytics.tenants_laundry_by_washmen.LndrViewPageEventBuilder;


